module.exports = __webpack_public_path__ + "img/Dirocco.1290f98e.jpeg";